import { render, staticRenderFns } from "./BathroomColorsTab.vue?vue&type=template&id=58c82354&"
import script from "./BathroomColorsTab.vue?vue&type=script&lang=ts&"
export * from "./BathroomColorsTab.vue?vue&type=script&lang=ts&"
import style0 from "./BathroomColorsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports